import { FC, useEffect, useState } from "react";
import { Button } from "@mantine/core";
import { useInterval } from "@mantine/hooks";
import { IconPlayerStopFilled } from "@tabler/icons-react";
import Time from "@/utils/time";
import Helper from "@/utils/helper";

const elapsed = (start: any) => {
    const startDate: any = Time.parseDate(start);
    const now: any = Time.now();
    return Helper.formatDuration(Math.abs(now - startDate) / 1000);
};

/* Shown in the job toolbar while the job's timer runs: the time so far, and a click stops it */
const JobRunningTimerButton: FC<{ timer: any; busy?: boolean; onStop: () => void }> = ({ timer, busy = false, onStop }) => {
    const [duration, setDuration] = useState(() => elapsed(timer.StartTime));
    const interval = useInterval(() => setDuration(elapsed(timer.StartTime)), 1000);

    useEffect(() => {
        setDuration(elapsed(timer.StartTime));
        interval.start();
        return interval.stop;
    }, [timer.StartTime]);

    return (
        <Button variant={'outline'} color={'red'} px={'sm'} style={{ flexShrink: 0, fontVariantNumeric: 'tabular-nums' }}
                leftSection={<IconPlayerStopFilled size={14} />} onClick={onStop} loading={busy}
                title={'Stop timer'} aria-label={'Stop timer'}>
            {duration}
        </Button>
    );
};

export default JobRunningTimerButton;
